<template>
  <div class="container content">
    <div class="headline">
      <h1>&nbsp;</h1>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-8">
        <article class="tile is-child box">
          <p class="title">{{ $t('message.how-to.header') }}</p>
          <div v-html="$t('message.how-to.txt')"></div>
        </article>
     </div>
    </div>  
  </div>
</template>

<script>
export default {
}
</script>